export default __webpack_public_path__ + "a7107582be87af43c33c66e05ec50ade.jpg";